import cs from "classnames";
import React from "react";

import { isMobile } from "src/common/hooks/useIsMobile";

import "./Page.css";

export const Page: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="page">{children}</div>;

interface ContentProps {
	alwaysShowScrollbar?: boolean;
	header?: React.ReactNode;
	body?: React.ReactNode;
}

export const Content: React.FunctionComponent<ContentProps> = ({
	alwaysShowScrollbar = false,
	header,
	body
}) => {
	const headerRef = React.useRef<HTMLDivElement | null>(null);
	const bodyRef = React.useRef<HTMLDivElement | null>(null);

	React.useEffect(() => {
		const { current: header } = headerRef;
		if (header === null) {
			return;
		}
		const { current: body } = bodyRef;
		if (body === null) {
			return;
		}
		const observer = new ResizeObserver(() => {
			if (isMobile()) {
				header.style.removeProperty("right");
				body.style.removeProperty("padding-top");
			} else {
				header.style.right = `${body.offsetWidth - body.clientWidth}px`;
				window.requestAnimationFrame(() => {
					body.style.paddingTop = `${header.offsetHeight + 20}px`;
				});
			}
		});
		observer.observe(body);
		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<div
			className={cs("content", {
				"content--always-show-scrollbar": alwaysShowScrollbar
			})}
		>
			{header && (
				<div className="header-wrapper" ref={headerRef}>
					<div className="header">{header}</div>
				</div>
			)}
			{body && (
				<div className="body" ref={bodyRef}>
					{body}
				</div>
			)}
		</div>
	);
};
